<div class="loading-overlay">
    <!-- Centered loader -->
    <div class="centered-loader">
        <unified-ui-loader [isLoading]="true" [loadingText]="loadingText()"></unified-ui-loader>
    </div>

    <!-- Skeleton UI -->
    <div class="skeleton-container">
        <!-- Title row -->
        @if (showTitle()) {
        <div class="skeleton-title">
            <div class="skeleton-cell header-cell"></div>
        </div>
        }
        <!-- Header row -->
        <div class="skeleton-header"
            [style.grid-template-columns]="showRowHeader() ? '60px repeat(' + numberOfColumns() + ', minmax(' + minColumnWidth() + ', 1fr))' : 'repeat(' + numberOfColumns() + ', minmax(' + minColumnWidth() + ', 1fr))'">
            @if (showRowHeader()) {
            <div class="row-header-cell">
                <div class="skeleton-cell header-cell"></div>
            </div>
            }
            @for (col of columns; track col) {
            <div class="column-cell">
                <div class="skeleton-cell header-cell"></div>
            </div>
            }
        </div>

        <!-- Data rows -->
        <div class="skeleton-body">
            @for (row of rows; track row) {
            <div class="skeleton-row" [ngClass]="{ 'even-row': row % 2 === 0, 'odd-row': row % 2 !== 0 }"
                [style.grid-template-columns]="showRowHeader() ? '60px repeat(' + numberOfColumns() + ', minmax(' + minColumnWidth() + ', 1fr))' : 'repeat(' + numberOfColumns() + ', minmax(' + minColumnWidth() + ', 1fr))'">
                @if (showRowHeader()) {
                <div class="row-header-cell">
                    <div class="skeleton-cell data-cell"></div>
                </div>
                }
                @for (col of columns; track col) {
                <div class="column-cell">
                    <div class="skeleton-cell data-cell"></div>
                </div>
                }
            </div>
            }
        </div>

        <!-- Footer -->

        @if (showFooter()) {
        <div class="skeleton-footer">
            <div class="skeleton-cell footer-cell-large"></div>
            <div class="footer-buttons">
                <div class="skeleton-cell footer-cell-small"></div>
                <div class="skeleton-cell footer-cell-small"></div>
            </div>
        </div>
        }
    </div>
</div>